import { render } from "./reset_password.vue?vue&type=template&id=7c20f7b8&scoped=true"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"

import "./reset_password.vue?vue&type=style&index=0&id=7c20f7b8&scoped=true&lang=css"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c20f7b8"]])

export default __exports__